import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import Dict from 'api/data-dict';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import { InputListBox } from 'containers/form';
import Button, { btnThemes } from 'components/button';
import { ModalButton, Header, Content, Footer } from 'components/modal';
import Notification from 'components/notification';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const bemClassesAdminPane = new Bem('adminPanelForum');
const classesBemForm = new Bem('modalContentAdmin');

// Show award button.
@apiDecorator
export default class AwardUserButton extends PureComponent {
  static propTypes = {
    answer_id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    medal_id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  };

  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.award = this.award.bind(this);
    this.onMedalChange = this.onMedalChange.bind(this);

    this.state = {
      chosenMedal: null
    };
  }

  onMedalChange(chosenMedal) {
    this.setState({ chosenMedal });
  }

  // Call after success remove award.
  afterAward(remove = false) {
    Notification.success(
      remove ?
        'Медаль успешно забрана у всех пользователей.' :
        'Медаль успешно назначена всем пользователям.'
    );

    if (remove && this.context && this.context.close) this.context.close();

    // Make reload data provider for Vote.
    emit('updateVote');

    return true;
  }

  // Send data with medal to backend for granting/removing award.
  award(answer_id, remove = false) {
    if (!remove && !this.state.chosenMedal) {
      return Notification.error('Выберите медаль');
    }

    this.api.post(`action/forum/actions-award-users/${remove ? 'delete' : 'award'}`, {
      postData: {
        answer_id,
        mid: remove ? this.props.medal_id : this.state.chosenMedal
      }
    })
      .then(() => this.afterAward(remove))
      .catch(error => reportError(error));
  }

  // Give users medal who gave right answer.
  render() {
    const { answer_id, medal_id } = this.props;

    // If users were awarded early.
    if (medal_id) {
      return (
        <Button
          title="Забрать медаль"
          label="Забрать медаль"
          onClick={() => this.award(answer_id, true)}
          theme={btnThemes.light}
        />
      );
    }
    const { chosenMedal } = this.state;

    return (
      <ModalButton
        buttonProps={{
          title: 'Наградить медалью',
          label: 'Наградить медалью',
          theme: btnThemes.light
        }}
        classNameModal={bemClassesAdminPane('modal', 'medals').className}
        size="big"
      >
        <Header closeButton children="Выбор медали" />
        <Content>
          <div {...classesBemForm()}>
            <Dict
              url="/forum/forum-medals"
              injectPropName="listBoxItems"
            >
              <InputListBox
                {...classesBemForm('list')}
                value={chosenMedal}
                dictValue="name"
                onChange={this.onMedalChange}
                nullValueItem={false}
                unselectableNonArrayInput
                radio
              />
            </Dict>
          </div>
        </Content>
        <Footer>
          <button
            title="Отмена"
            label="Отмена"
            theme={btnThemes.light}
            close
          />
          <button
            title="Наградить"
            label="Наградить"
            onClick={() => this.award(answer_id)}
            close={!!chosenMedal}
            theme={btnThemes.sky}
          />
        </Footer>
      </ModalButton>
    );
  }
}
